var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesProcessed01 = function SvgMessagesProcessed01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "messages_processed-01_svg2__a",
    x1: -20.47,
    x2: 192.53,
    y1: 170.84,
    y2: 35.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#messages_processed-01_svg2__a",
    id: "messages_processed-01_svg2__b",
    x1: -28.46,
    x2: 184.54,
    y1: 158.24,
    y2: 23.24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#messages_processed-01_svg2__a",
    id: "messages_processed-01_svg2__c",
    x1: -19.78,
    x2: 193.22,
    y1: 171.93,
    y2: 36.93
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M147.47 42.93H25.8C11.57 42.97.04 54.5 0 68.73v102.53c.04 6.87 5.6 12.43 12.47 12.47 2.71.02 5.35-.85 7.53-2.46L42.87 164c.93-.69 2.05-1.07 3.2-1.07h101.47c14.26-.04 25.8-11.61 25.8-25.87V68.73c-.04-14.26-11.61-25.8-25.87-25.8m12.52 94.15c0 6.92-5.61 12.53-12.53 12.53H46.06c-4.04.02-7.96 1.32-11.2 3.73l-21.53 16.27V68.74c.04-6.87 5.6-12.43 12.47-12.47s121.72 0 121.72 0c6.87.04 12.43 5.6 12.47 12.47v68.33Z",
    style: {
      fill: "url(#messages_processed-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2 16.26H40c-3.69 0-6.67 2.98-6.67 6.67S36.32 29.6 40 29.6h134.19c6.87.04 12.43 5.6 12.47 12.47v67.53c0 3.69 2.99 6.67 6.67 6.67 3.69-.01 6.67-3 6.67-6.68V42.06c-.04-14.23-11.57-25.76-25.8-25.8",
    style: {
      fill: "url(#messages_processed-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7 98.14c-.24-.3-.55-.49-.94-.54l-8.22-1.22c-.45-1.39-1.06-2.81-1.84-4.25q.81-1.08 2.43-3.06c1.62-1.98 1.84-2.28 2.29-2.89.24-.32.36-.65.36-1 0-.4-.1-.72-.31-.95q-1.62-2.22-7.41-7.38c-.36-.29-.73-.43-1.12-.43q-.675 0-1.08.39l-6.38 4.64c-1.23-.61-2.58-1.14-4.04-1.61l-1.26-7.99c-.03-.38-.2-.69-.52-.93-.31-.25-.68-.37-1.1-.37h-9.97c-.87 0-1.41.4-1.62 1.22-.39 1.45-.82 4.14-1.3 8.07-1.41.43-2.77.98-4.09 1.65l-6.2-4.64c-.39-.29-.78-.43-1.17-.43-.66 0-2.07 1.03-4.25 3.1-2.17 2.07-3.65 3.62-4.43 4.67-.27.38-.4.71-.4 1 0 .35.15.69.45 1.04 2.01 2.34 3.61 4.34 4.81 5.99-.75 1.33-1.33 2.66-1.75 3.99l-8.36 1.22c-.33.06-.61.25-.85.56-.24.32-.36.65-.36 1v9.64q0 .57.36 1.02c.24.3.55.49.94.54l8.22 1.17c.42 1.42 1.03 2.85 1.84 4.3q-.81 1.08-2.43 3.06c-1.62 1.98-1.84 2.28-2.29 2.89-.24.32-.36.65-.36 1 0 .38.1.71.31 1q1.755 2.34 7.41 7.29c.33.32.7.48 1.12.48.45 0 .82-.13 1.12-.39l6.34-4.65c1.23.61 2.58 1.14 4.04 1.61l1.26 7.99c.03.38.2.69.52.93.31.25.68.37 1.1.37h9.97c.87 0 1.41-.4 1.62-1.22.39-1.45.82-4.14 1.3-8.07 1.41-.43 2.77-.98 4.09-1.65l6.2 4.69q.63.39 1.17.39c.66 0 2.07-1.03 4.22-3.08 2.16-2.05 3.64-3.62 4.45-4.69.27-.29.4-.62.4-1s-.15-.74-.45-1.09c-2.16-2.55-3.76-4.54-4.81-5.99.6-1.07 1.18-2.39 1.75-3.95l8.31-1.21q.54-.09.9-.57c.36-.48.36-.65.36-1v-9.64q0-.57-.36-1.02zm-26.01 13.6c-2.25 2.17-4.96 3.26-8.13 3.26s-5.89-1.09-8.13-3.26c-2.25-2.17-3.37-4.79-3.37-7.86s1.12-5.69 3.37-7.86 4.96-3.26 8.13-3.26 5.89 1.09 8.13 3.26c2.25 2.17 3.37 4.79 3.37 7.86s-1.12 5.69-3.37 7.86",
    style: {
      fill: "url(#messages_processed-01_svg2__c)"
    }
  }));
};
export default SvgMessagesProcessed01;